import { Box, Typography } from "@mui/material";
import { StageColumn } from "./StageColumn";

export const BoardView = ({
  stages,
  columns = {},
  onLoadMore,
  onDragStart,
  onDragOver,
  onDrop,
  onDealClick,
  onEditStage,
  onDeleteStage,
  onAddStage,
}) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          overflowX: "auto",
          pb: 1,
        }}
      >
        {/* Check if there are no stages */}
        {stages.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              minHeight: "200px",
              bgcolor: "#FAFAFA",
              borderRadius: 2,
              border: "2px dashed #D1D5DB",
              color: "#6B7280",
              textAlign: "center",
              py: 3,
            }}
          >
            <Typography fontWeight={600} fontSize="1rem" color="#6B7280">
              No Stage Here
            </Typography>
          </Box>
        ) : (
          // Render StageColumns if stages exist
          stages.map((stage) => (
            <StageColumn
              key={stage._id}
              stage={stage}
              column={columns[stage._id]}
              onLoadMore={() => onLoadMore?.(stage._id)}
              onDragOver={onDragOver}
              onDrop={onDrop}
              onDealClick={onDealClick}
              onDragStart={onDragStart}
              onEditStage={onEditStage}
              onDeleteStage={onDeleteStage}
            />
          ))
        )}

        {/* Add Stage Card */}
        <Box
          onClick={onAddStage}
          sx={{
            minWidth: 160,
            maxWidth: 160,
            height: "fit-content",
            bgcolor: "#FAFAFA",
            border: "2px dashed #D1D5DB",
            borderRadius: 2,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#6B7280",
            cursor: "pointer",
            py: 2,
            transition: "all 0.25s",
            "&:hover": {
              bgcolor: "#F3F4F6",
              borderColor: "#9CA3AF",
              color: "#111827",
            },
          }}
        >
          <Typography fontWeight={600} fontSize="0.95rem">
            + Add Stage
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};